export const NAME = 'criteria';

export const REQUEST_CRITERIA = 'REQUEST_CRITERIA';
export const RECEIVE_CRITERIA = 'RECEIVE_CRITERIA';
export const FAILURE_CRITERIA = 'FAILURE_CRITERIA';

// Criteria types
export const CATEGORIES = 'CATEGORIES';



// WEBPACK FOOTER //
// ./src/services/criteria/constants.js